import dashboard from './dashboard';
import statistics from './statistics';

const menuItems = {
  items: [dashboard, statistics]
};

export default menuItems;
